import videoOverlay from './video-overlay';
import aboutUs from '../../../byron/about-us';

$(document).ready(() => {
  // Initialise youtube iframe api
  var tag = document.createElement('script');
  tag.src = 'https://www.youtube.com/iframe_api';
  var firstScriptTag = document.getElementsByTagName('script')[0];
  firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

  window.onYouTubeIframeAPIReady = () => {
    videoOverlay('#cover-block-video-overlay');
    aboutUs();
  };
});
